<template>
	<div>
		<Breadcrumbs main="" title="reuse.header"/>
		<!-- Container-fluid starts-->
		<div class="container-fluid search-page">
            <!-- <div>
                <svg width="400" height="300">
                    <rect x="50" y="50" width="100" height="50" @click="blockClicked('block1')" style="fill:lightblue;stroke:black;cursor:pointer" />
                    <text x="75" y="75" dominant-baseline="middle" text-anchor="middle">Block 1</text>
                    <rect x="250" y="50" width="80" height="50" @click="blockClicked('block2')" style="fill:lightgreen;stroke:black;cursor:pointer" />
                    <text x="275" y="75" dominant-baseline="middle" text-anchor="middle">Block 2</text>
                    <line x1="150" y1="75" x2="250" y2="75" style="stroke:black;stroke-width:2" />
                </svg>
            </div> -->
			<div class="row">
                <div class="col-sm-6 gradient-wy">
                    <form class="theme-form">
                        <div class="ml-1 mb-4">
                            <h2 class=" text-dark f-w-600 ml-3">{{ $t('reuse.header') }}</h2>
                            <h5 class=" text-info f-w-600 ml-3" style="font-size: 14px;">{{ $t('reuse.autoCheck') }}</h5>
                            <div class="col-sm-12">
                                <div class="row">
                                    <label for="selectedBkgId" class="col-form-label pt-0 f-w-600" style="font-size:16px;">1. {{ $t("reuse.bkgId") }}</label>                                      
                                        <router-link to="/resource/bookingId">
                                        <feather  v-show="!showBkgIdInput" v-b-tooltip.hover :title="$t('bookingId.addBooking')" type="plus-circle" class="ml-2"></feather>
                                    </router-link>                                 
                                    </div>
                                <v-select 
                                    v-if="!showBkgIdInput" 
                                    class="style-chooser" 
                                    style="font-size:16px;" 
                                    v-model="selectedBkgId" 
                                    @input="trigContListByAgentGroup" 
                                    :options="bkgIdList" 
                                    :placeholder="$t('reuse.bkgIdPh')">                            
                                    <template #no-options>
                                            {{$t('reuse.noMatchingOptions')}}
                                    </template>
                                </v-select>
                                <div v-else class="col-sm-5">
                                    <router-link to="/resource/bookingId">
                                        <b-button pill size="sm" class="bg-primary">
                                            <span class="f-w-600 text-white" style="font-size: 16px;">{{ $t('bookingId.addBooking') }} </span>
                                        </b-button>                                          
                                    </router-link>
                                </div>
                            </div>
                        </div>                           
                        <div class="row ml-1 mb-4">
                            <div class="col-sm-6">
                                <div class="row">
                                    <label for="selectedContId" class="col-form-label pt-0 f-w-600" style="font-size:16px;">2. {{ $t("reuse.contNo") }}</label> 
                                    <router-link to="/resource/container">
                                        <feather  v-b-tooltip.hover :title="$t('container.add')" type="plus-circle" class="ml-2"></feather>
                                    </router-link>
                                </div>
                                <!-- <v-select label="selectedCont" class="style-chooser" v-model="selectedCont" :options="contList" :placeholder="$t('reuse.contNoPh')"/> -->
                                <v-select  class="style-chooser" 
                                    style="font-size:16px;" 
                                    v-model="selectedContId" 
                                    @input="trigSealNoListByAgentGroup" 
                                    :options="contList" 
                                    :reduce="text => text.value"
                                    label = "text"
                                    :placeholder="$t('reuse.contNoPh')">   
                                    <template #no-options>
                                        {{$t('reuse.noMatchingOptions')}}
                                    </template>
                                </v-select>
                            </div>                             
                            <div class="col-sm-6">
                                <div class="row">
                                    <label for="selectedSealNo" class="col-form-label pt-0 f-w-600" style="font-size:16px;">3. {{ $t("reuse.sealNo") }}</label> 
                                    <router-link to="/resource/seal">
                                        <feather  v-b-tooltip.hover :title="$t('seal.addSeal')" type="plus-circle" class="ml-2"></feather>
                                    </router-link>
                                </div>
 
                                <v-select  
                                    class="style-chooser" 
                                    style="font-size:16px;" 
                                    v-model="selectedSealNo" 
                                    :options="sealNoList" 
                                    :placeholder="$t('reuse.sealNoPh')">    
                                    <template #no-options>
                                        {{$t('reuse.noMatchingOptions')}}
                                    </template>
                                </v-select>
                                <!-- <v-select label="selectedSealNo" class="style-chooser"  :value="selectedSealNo" @input="getSealNoListByAgentGroup" :options="sealNoList" :placeholder="$t('reuse.sealNoPh')"/>                                    -->
                            </div>                            
                        </div>   
                      
                        <div class="form-group ml-3 my-5 text-primary f-w-600">
                            <div class="row">
                                <label for="contRueAddress" class="col-form-label pt-0 ml-3">{{ $t("reuse.locReu") }}</label>    
                                <p class=" ml-2 fw-bold text-danger"  > {{ $t("reuse.ifChg") }}</p>
                                <a href="#googleMapReu"><u class=" ml-2 fw-bold text-info" style="font-size:15px" @click="showAC"> <i class="icofont icofont-map-search mr-2 " style="font-size:25px"></i>Google Map </u></a>                                
                            </div>
                            <!-- <input v-model="contReuAddress" class="form-control text-info" type="text" id="contReuAddress" :placeholder="$t('reuse.locReuPh') " > -->
                            <span class="f-w-60 text-primary ml-2" style="font-size:14px;"> {{ contReuAddress }}</span>
                            <h6 class=" ml-3 text-info"> Latitude : {{ locReu.lat }}  ,  Longitude : {{ locReu.lng }}</h6>
                        </div> 

                        <div class="form-group mt-3 my-4 mb-0">
                            <button 
                                class="btn btn-primary btn-block" 
                                style="font-size:20px" type="button" 
                                @click="handleProcess"
                                :disabled="this.selectedBkgId == '' || this.selectedContId == '' || this.selectedSealNo ==''"
                                >{{ $t('reuse.submit') }}
                            </button>
                        </div>
                    </form>
                </div>
                <div class="col-sm-6" id="googleMapReu" >
                    <section class="ui one column centered grid mt-5" v-show="showAutoComplete" style="position:relative; z-index: 5;">
                        <div class="column" >
                            <form class="ui left segment small form" >
                                <div class="ui message red" v-show="error">{{ error }}</div>
                                <div class="field" >
                                    <div class="row mb-3 col-sm-12">
                                        <div class=" col-sm-1">
                                            <i class="icon times text-primary" style="font-size: 24px;"  @click="offAC" ></i>                                                    
                                        </div>
                                        <div class="col-sm-11">
                                            <span class="text-warning"> {{ $t('company.donotEnterKey') }}</span>       
                                        </div>                                
                                    </div>
                                    
                                    <!-- <div class="ui message blue" >{{ compAddress }}</div> -->
                                    <div class="ui right icon input large" :class="{loading:spinner}">
                                        <input 
                                            type="text"
                                            v-b-popover.hover="$t('company.inputLocNameMsg')" 
                                            :title="$t('company.inputLocName')"  
                                            id="autocompleteReu"
                                            v-model="address"
                                            onkeypress= "return event.keyCode != 13;"
                                        >
                                        <i 
                                            class="dot circle link icon" 
                                            @click="locatorButtonPressed"
                                            v-b-popover.hover.top="$t('company.useCurrPosition')"
                                        ></i>
                                    </div>
                                    <!-- dummy input to fix bug : only one input, make reload if we press ENTER.  -->
                                    <!-- <div class="ui message red" v-show="false">
                                        <input 
                                            type="text" 
                                        >
                                    </div> -->
                                </div>
                                <div class="row" @click="clearAddress">
                                    <i class="icon eraser f-10 ml-4 text-danger"  style="font-size: 18px;"></i>
                                    <span class="ml3 text-info" > {{ $t('company.clearAddress') }} </span>
                                    
                                </div>
                            </form>                               
                        </div>
                    </section> 
                    <section id="mapReu" style="background-color: lightblue;"></section>   
                </div>
            </div>
            <b-alert v-model="showAlertWallet" variant="danger" dismissible class="col-sm-6">
                <h4 class="alert-heading f-w-800">{{ $t("release.walletCompNotEnough")}}</h4>
                <div class="row ml-1">
                    <span>{{ $t("release.balancedAmount") }}</span>
                    <span class="text-dark f-w-800 mx-2" style="font-size: 16px;">{{ balanced}}</span>
                    <span>{{ $t("refill.mUnit") }}</span>
                </div>
                <div>
                    <span>{{ $t("release.refillOrContact") }}</span>
                </div>
            </b-alert>
            <div>
                <h4 class="mb-1 mt-4 f-w-600">{{ $t('reuse.activeReuseList') }}</h4>
                <b-table
                    sticky-header
                    head-variant="light"
                    table-variant="success"
                    show-empty
                    responsive
                    sort-icon-left
                    stacked="md"      
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :items="items"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                >
                    <template #cell(act)="row" >
                        <b-button v-show="row.item.status != 'Cancel' " size="sm" @click="actCancel(row.item)" class="m-1">
                            {{ $t('matchTx.cancel') }}
                        </b-button>
                    </template>
                    <template #cell(addressReu)="row" >
                        <b-button  size="sm" v-b-popover.hover.top="row.item.contReuAddress" variant="outline-info">
                            {{ $t('matchTx.reqr') }}
                        </b-button>
                    </template>
                    <template #cell(contImage)="row" >
                        <b-button  size="sm" @click="openModalImage(row.item, row.index, $event.target )" class="m-1">
                            {{ row.item.contNo == 'Dummy' || row.item.contNo == 'dummy' || row.item.contNo == '' ? `${$t('container.dummy')}` : row.item.contNo }}
                        </b-button>
                    </template>
                    <template #empty>
                        <h5>{{ $t('reuse.noRecord') }}</h5>
                    </template>
                </b-table>
                <b-row>
                    <div class="row col-sm-8">
                    <b-col class="my-1 ml-3">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        class="my-0"
                        ></b-pagination>
                    </b-col>   
                    <b-col sm="3" md="6" class="my-1">
                        <b-form-group
                        :label= "$t('require.perPage')"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                        >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                    </div>
                </b-row>
                    <!-- Info modal Container Image-->
                <b-modal 
                    id="contModal" 
                    :title="modalTitle" 
                    ok-only 
                    @hide="resetInfoModal"
                >
                    <div class="gradient-yg p-1" >
                        <div class="dashboard">
                            <div class="image-scroll-container">
                                <div class="image-scroll" ref="scrollContainer">
                                    <div
                                    class="image-item"
                                    v-for="(image, index) in imageUriModal"
                                    :key="image.id"
                                    >
                                    <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                                    <span class="image-counter">{{ index + 1 }} of {{ imageUriModal.length }}</span>
                                    </div>
                                    <div v-if="imageUriModal.length === 0" class="no-images">
                                    {{$t('approvedTrans.noImageYet') }}
                                    </div>
                                </div>
                                <div class="scroll-controls" v-if="imageUriModal.length > 1">
                                    <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                                    <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                                    <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                                    <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                                </div>
                            </div>                        
                        </div>
                    </div>
                </b-modal>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>


import {getBalance, uaTxWallet, bkgIdList, updateActive, updateStatus, updateMatchTx2StepN, mTxIdReuByReuId ,compNameLocalByCompId, contAgent, sealNoListAgentGroup, contListAgentGroup ,agentAtContId, locByCompId, saveWithId, agentAtBkgId, getData} from "../../firebase"
import {reuCost} from '../../constants/config'
import {getRandomInt, showUserLocationOnTheMap } from "../../utilities/util" 
import {getAddressFrom} from "../../utilities/axiosComp" 
export default {
	data(){
		return{
            balanced: 0,
            showBkgIdInput: false,
            showAlertWallet: false,
            showAutoComplete : false,
            bkgIdList : [],
            contList : [],
            sealNoList : [],
            address : '',
            error : '',        
            spinner: false,
            format: "yyyy-MM-dd",
            selectedBkgId : '',
            selectedContId : '',
            selectedSealNo : '',
            contReuAddress: '',
            locReu : '',
            userId: '',
            compId: '',
            items: [],
            fields: [
                { key: 'reuId', label: this.$t('require.reqrId'), sortable: true, },  
                { key: 'bkgId', label: this.$t('require.bkgId'), sortable: true, }, 
                { key: 'agent', label: this.$t('require.agentByBkgId'), sortable: true, },                    
                { key: 'contImage', label: this.$t('container.contNo'), variant: 'info'}, 
                { key: 'detDate', label: this.$t('container.detDate'), sortable: true, },                 
                { key: 'sealNo', label: this.$t('seal.sealNo'), sortable: true,},
                { key: 'contType', label: this.$t('require.contType'), sortable: true, },
                { key: 'contSize', label: this.$t('require.contSize'), sortable: true, },
                { key: 'contGrade', label: this.$t('require.contGrade'), sortable: true, },
                { key: 'compNameLocalReu', label: this.$t('reuse.compNameLocalReu'), sortable: true, },                
                { key: 'addressReu', label: this.$t('matchTx.address'), sortable: false, }, 
                // { key: 'contReuAddress', label: this.$t('matchTx.contReqrAddress'), sortable: false, },              
                { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, 
                    formatter: value => {
                        return this.$moment(value).format("DD-MM-YY @ HH:mm")
                }},
                { key: 'status', label: this.$t('matchTx.jobStatus'), variant: 'warning', sortable: true,
                    formatter: value => {
                        return this.$t(`reuse.${value}`)
                }},
                { key: 'act', label: this.$t('matchTx.actions'), variant: 'danger'}
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortBy: 'timestamp',
            sortDesc: true,
            sortDirection: 'asc',
            imageUriModal: [],
            modalTitle : ''
		}
	},
	components: {
	},
	mounted(){
        let compId= localStorage.getItem("compId")
        let userId= localStorage.getItem("userId")
        this.compId = compId
        this.userId= userId        
        bkgIdList(compId, (res)=>{
            if (res.length == 0) {
                this.showBkgIdInput = true
            } else {
                this.bkgIdList = res
            }
        })
        getData( "Reuse","compId", this.compId, (res)=>{
            this.items= res
            this.totalRows = res.length
        })
        locByCompId(compId ,(res)=>{
            this.locReu = {
                    lat : res.compLoc.lat,
                    lng : res.compLoc.lng
                }
            this.contReuAddress = res.compAddress
            showUserLocationOnTheMap(res.compLoc.lat, res.compLoc.lng , "mapReu" )
        })
        var autocomplete = new google.maps.places.Autocomplete(
            document.getElementById('autocompleteReu'),
            {
                bounds: new google.maps.LatLngBounds(
                    new google.maps.LatLng(13.555 , 100.50)
                )
            }
        )
        autocomplete.addListener("place_changed",  ()=>{
            let place = autocomplete.getPlace()
            // console.log("place =>"+ JSON.stringify(place , null , 2))
            let lat = place.geometry.location.lat()
            let lng = place.geometry.location.lng() 
            if (!place.geometry) {
                this.$toasted.show(this.$t("require.fillinMatchedChar"), {theme: 'bubble',   position: 'bottom-right',   type: 'error', duration: 15000});
            } else {
                showUserLocationOnTheMap(lat, lng , "mapReu")
                this.locReu = {
                    lat : lat,
                    lng : lng
                }
                getAddressFrom(lat, lng, (res)=>{
                    if (res.resp == 'err') {
                        this.error = res.msg
                    } else {
                        this.contReuAddress = res.msg
                        this.address = res.msg
                    }
                    this.spinner = false
                } )
            }
        })        
	},
	methods:{
        // blockClicked(blockId) {
        // console.log(`Block ${blockId} clicked!`);
        // // Perform your action here based on the blockId
        // },
        async trigContListByAgentGroup( value){
            console.log(`input trig value =>${value}`)
            if (value) {
                // this.selectedBkgId = value
                await agentAtBkgId(value, this.compId, async(agent)=>{
                    await contListAgentGroup(this.compId, agent, (res)=>{
                    this.contList = res
                    })
                })
            } 
        },
        async trigSealNoListByAgentGroup( value){
            if (value) {
                this.selectedContId = value
                await contAgent(value, async(agent)=>{
                    await sealNoListAgentGroup(this.compId, agent, (res)=>{
                    this.sealNoList = res
                    })
                })
            } else {
                this.$toasted.show(this.$t('reuse.addSelectedCont'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000}); 
            }
        },
        locatorButtonPressed(){
            this.spinner =true
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) =>{ 
                        let lat = position.coords.latitude
                        let lng = position.coords.longitude
                        showUserLocationOnTheMap(lat, lng, "mapReu" )
                        this.locReu = {
                            lat : lat,
                            lng : lng
                        }
                        getAddressFrom(lat, lng, (res)=>{
                            if (res.resp == 'err') {
                                this.error = res.msg
                            } else {
                                this.contReuAddress = res.msg
                                this.address = res.msg
                            }
                            this.spinner = false
                        } )
                    },
                    error => {
                        this.error = "Locator is unable to find the address. Please type your address manually."
                        this.spinner =false
                    }
                );
            } else {
                this.error = error.message
                this.spinner =false
                // console.log(`Your browser does not support geolocation API. Please enter your address`);
            }
        },
        // showUserLocationOnTheMap(latitude , longitude){
        //     // Creat a map object
        //     let map = new google.maps.Map(document.getElementById("mapReu"),{
        //         zoom:15,
        //         center: new google.maps.LatLng(latitude, longitude),
        //         mapTypeId: google.maps.MapTypeId.ROADMAP
        //     })
        //     // Add marker
        //     new google.maps.Marker({
        //         position: new google.maps.LatLng(latitude, longitude),
        //         map: map
        //     })
        //     // await new google.maps.marker.AdvanceedMarkerElement({
        //     //     position: await new google.maps.LatLng(latitude, longitude),
        //     //     map: map
        //     // })
        // },
        clearAddress(){
            this.address = ''
        },
        showAC(){
            if (this.showAutoComplete == false) {
                this.showAutoComplete = true
            } else {
                this.showAutoComplete = false
            }
        },
        offAC(){
            if (this.showAutoComplete == true) {
                this.showAutoComplete = false
            } 
        },
        handleProcess(){
            getBalance(this.compId , async(res)=>{
                if (res < reuCost) {
                    this.balanced = res 
                    this.showAlertWallet = true
                } else {
                    let msg = 'completed'
                    if (this.selectedBkgId ==='') {
                        msg = 'reuse.addSelectedBkgId'
                    } else if (this.selectedCont ===''){
                        msg = 'reuse.addSelectedCont'
                    } else if (this.selectedSealNo ===''){
                        msg = 'reuse.addSelectedSealNo'
                    } else if (this.contReuAddress ===''){
                        msg = 'reuse.addContReuAddress'
                    } else if (this.LocReqr== ''){
                        msg = 'reuse.useGoogleMap'
                    }  
                    if (msg === 'completed'){
                        agentAtContId(this.selectedContId , async(res)=>{
                            let reuId = `${this.$moment().format("YYMM")}`+'RU'+`${getRandomInt( 10000, 90000)}`
                            let compNameLocalReu = await compNameLocalByCompId(this.compId)
                            let payload = {
                                reuId : reuId,
                                bkgId : this.selectedBkgId,
                                sealNo : this.selectedSealNo,
                                contReuAddress: this.contReuAddress,
                                locReu: this.locReu,            
                                compId : this.compId,
                                compNameLocalReu : compNameLocalReu,
                                userId : this.userId,
                                status: "Matched",
                                timestamp: Date.parse(new Date()),
                                ...res
                            }
                            // console.log ('payload=>'+JSON.stringify(payload , null, 2))
                            await saveWithId('Reuse', reuId, payload).then(async()=>{
                                await this.saveMatchTx(payload)
                                await updateActive('Container', this.selectedContId, false);
                                await updateActive("Seal", this.selectedSealNo, false) // exhuast the used seal out 
                                this.resetReuseInputForm()
                                let slipId =  `${this.$moment().format("YYMMDDHH")}-${getRandomInt( 10000, 90000)}`
                                await uaTxWallet(reuCost * -1, this.compId, slipId, "auto", "expense", "make reuse" ,reuId)
                                await this.refresh().then(()=>{
                                    this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 10000});    
                                    // window.location.reload()
                                })                                
                            })
                        })                                  
                    }else{
                        this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
                    }  
                }
            })
        },

        async saveMatchTx( payload){
            let ts = Date.parse(new Date())
            let mTxId = `${this.$moment().format("YYMM")}`+'MT'+`${getRandomInt( 10000, 90000)}`
            const data = {
                mTxId : mTxId,
                contId : payload.contId,
                contNo : payload.contNo,
                distance: 0,
                bkgId: payload.bkgId, 
                compNameLocalRels: payload.compNameLocalReu,           
                contRelsAddress:  payload.contReuAddress,
                locRels: payload.locReu,    
                compNameLocalReqr :  payload.compNameLocalReu,             
                contReqrAddress: payload.contReuAddress,                
                locReqr: payload.locReu,    
                jobTypeRels: 'Internal',
                jobTypeReqr: 'Internal',
                transCompId : payload.compId,
                transStatus : 'noTransServ',
                sRelsTS : ts,
                sReqrTS : ts,
                msReqr: 'matched',
                jbReqr:'waitApprovalReu',
                actReqr:{
                    cancel:false, 
                    accept: false, 
                    reject:false, 
                    attachSeal:false
                },  
                actRels:{
                    cancel:false, 
                    accept: false, 
                    reject:false, 
                    attachSeal:false
                },
                stepNo: 2,                                               
                msRels: 'matched',
                jbRels: 'waitApprovalReu',
                compIdRels: payload.compId,
                compIdReqr : payload.compId,
                userIdRels: payload.userId,
                userIdReqr: payload.userId,
                relsTS: ts,
                reqrTS: ts,
                relsId: payload.reuId,                
                reqrId: payload.reuId,
                txSearcher: "Reuse", 
                timestamp: ts,
                active: true,                   
                sealNo : payload.sealNo,
                detDate : payload.detDate,
                detTS: payload.detTS,
                contType : payload.contType,
                contSize : payload.contSize,
                contGrade : payload.contGrade,
                maxGross : payload.maxGross,
                tare : payload.tare,
                agent : payload.agent,
                shoreStatus:'waitRequest',
            }
            await saveWithId('MatchTx', mTxId, data).then(async()=>{
                await saveWithId('jbStatusReqr' , `${mTxId}-${ts}` , {
                    id : mTxId,
                    jbReqr : data.jbReqr,
                    timestamp : ts,
                })
                await saveWithId('jbStatusRels' , `${mTxId}-${ts}` , {
                    id : mTxId,
                    jbRels : data.jbRels,
                    timestamp : ts,
                })
                await saveWithId('transStatus' , `${mTxId}-${ts}` , {
                    id : mTxId,
                    transStatus : 'noTransServ',
                    timestamp : ts,
                })               
            })
         

        },
        actCancel(item) {
            this.$bvModal.msgBoxConfirm(this.$t('reuse.confirmCancelMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async (value) => {
                if (value) {
                    await mTxIdReuByReuId( item.reuId, async(res)=>{    // reuId = reqrId for Reuse
                        if (res.length == 0) {
                            this.$toasted.show( this.$t('reuse.noData'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                        } else {
                            if (res.msReqr == "approved" || res.msRels == "approved" ) {
                                this.$toasted.show( this.$t('reuse.approved'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                            } else {
                                await updateMatchTx2StepN('MatchTx', res.mTxId , 1.1) 
                                await updateStatus('Reuse', item.reuId, 'Cancel')// return  status of Poster for recycle.
                                await updateActive('Container', item.contId, true);
                                await updateActive('Seal', item.sealNo, true )
                                await this.refresh().then(()=>{
                                    // window.location.reload()
                                })
                                let slipId =  `${this.$moment().format("YYMMDDHH")}-${getRandomInt( 10000, 90000)}`
                                await uaTxWallet(reuCost, this.compId , slipId, "auto", "refund", "cancel reuse",item.reuId)
                                this.$toasted.show( this.$t('reuse.cancelled'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});                                 
                            }
                        }       
                    }) 
                } else {
                    return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },  
        async refresh(){
            await getData( "Reuse","compId" , this.compId , (res)=>{
                this.items= res
                this.totalRows = res.length
            })
            this.contList = []
            this.sealList = []
        },
        resetReuseInputForm(){
            this.selectedBkgId = ''
            this.selectedCont = ''
            this.selectedSealNo = ''
        },
        async openModalImage(item, index, button) {
            await getData('Container' , 'contId' , item.contId , (res)=>{
            this.imageUriModal = res[0].url6  
            this.modalTitle = res[0].contNo   
            this.$root.$emit('bv::show::modal', "contModal" , button)                                  
            })
        },
        resetInfoModal() {
            this.modalTitle = ''
            this.imageUriModal = []
        },
        scrollLeft() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },  
        scrollLeftS1() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        }, 
        scrollRight() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },
        scrollRightS1() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        },
    }
}
</script>
<style scoped>
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
.ui.button,
.dot.circle.icon{
    background-color: #138fc0;
    color : white
}
#mapReu {
    position:absolute;
    top:0;
    right:0;
    bottom: 0;
    left: 0;
    background: blue;
}

.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  /* text-transform: lowercase;
  font-variant: small-caps; */
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
.gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
 .dashboard {
  padding: 10px;
  max-width: 100%;
  overflow-x: hidden;
}
.image-scroll-container {
  position: relative;
  margin: 20px 0;
}

.image-scroll {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  width: 100%;
}

.image-scroll::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome/Safari */
}

.image-item {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
}
.display-image {
width: 100%;
  height: 400px;
  object-fit: contain;
  border-radius: 8px;
  background-color: #f5f5f5;
  }
  .image-counter {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 14px;
}

.no-images {
  text-align: center;
  width: 100%;
  padding: 50px 0;
  color: #666;
  font-style: italic;
  font-size: 16px;
}

.scroll-controls {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.scroll-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 15px;
  margin: 0 5px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}
</style>
